import { t } from "adapters/i18n";
import type { Dispatch } from "react-redux";
import rainService from "services/rainService";
import { getErrorMessage } from "shared/errorUtils";
import fileUtils from "shared/fileUtils";
import { notifyError, notifySuccess } from "../actions";
import type { RootState } from "../reducers";

export const downloadRainHistoryCsv =
  (retreatId: number) =>
  async (
    dispatch: Dispatch<unknown>,
    getState: () => RootState
  ): Promise<void> => {
    try {
      const { fazenda } = getState();
      const farmId = fazenda.FazendaSelecionada;

      if (farmId == null) {
        throw new Error(t("common:no-farm-selected"));
      }

      const historyCsv = await rainService.getFarmRainHistoryCsv(
        farmId,
        retreatId
      );

      fileUtils.downloadCsvFile("HistoricoChuva.csv", historyCsv);

      dispatch(notifySuccess({ mensagem: t("rain:download-history-success") }));
    } catch (error) {
      const message = getErrorMessage(error);
      dispatch(notifyError({ mensagem: message }));
    }
  };

export const importRainHistoryCsv =
  (retreatId: number, file: File) =>
  async (
    dispatch: Dispatch<unknown>,
    getState: () => RootState
  ): Promise<void> => {
    try {
      const { fazenda } = getState();
      const farmId = fazenda.FazendaSelecionada;

      if (farmId == null) {
        throw new Error(t("common:no-farm-selected"));
      }

      await rainService.updateFarmRainHistory(farmId, retreatId, file);

      dispatch(notifySuccess({ mensagem: t("rain:import-history-success") }));
    } catch (error) {
      const message = getErrorMessage(error);
      dispatch(notifyError({ mensagem: message }));
    }
  };
